/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { resolveReferences } from '../../../JsonReferenceResolver'
import { HttpClient } from '@angular/common/http'

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-data-status',
    templateUrl: './data-status.component.html',
    styleUrls: ['./data-status.component.less'],
})
export class DataStatusComponent implements OnInit {
    constructor(private $http: HttpClient) {}

    public pendingList: any = []

    ngOnInit(): void {
        let vm = this

        vm.getPending()
    }

    getPending() {
        let vm = this
        vm.$http
            .get('/api/clik-data/pending')
            .toPromise()
            .then(
                function (response: any) {
                    response = resolveReferences(response)
                    vm.pendingList = response
                },
                function (response: any) {
                    console.error('Error getting pending data...', response)
                }
            )
    }

    commitData() {
        let vm = this
        vm.$http
            .post('/api/clik-data/commit', {})
            .toPromise()
            .then(
                function (response: any) {
                    vm.getPending()
                },
                function (response: any) {
                    console.error('Error committing data...', response)
                }
            )
    }
}
